import React from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";
import SectionHeader from "components/SectionHeader";
import PageSection from "components/PageSection";
import "./Blog.scss";
import CardHover from "components/Card/CardHover";

const Blog = ({ className, frontmatter }) => {
  if (!frontmatter) {
    return null;
  }

  const {
    anchor,
    header: rootHeader,
    subheader: rootSubHeader,
    content: rootContent,
    blogs,
  } = frontmatter;

  return (
    <PageSection className="bg-light" id={anchor}>
      <Row>
        <SectionHeader header={rootHeader} subheader={rootSubHeader} />
      </Row>
      <Row>
        {blogs.map((item, idx) => {
          console.log("item", item);
          const { imageCover, title, description, labels, link } = item;
          const key = `${idx}${title}`;
          return (
            <Col sm={12} lg={4} md={6} key={key}>
              <CardHover
                link={link}
                labels={labels}
                description={description}
                imageCover={imageCover}
                title={title}
              />
            </Col>
          );
        })}
      </Row>
      {/* <Row>
        {teamMember.map(({ header, ...tmProps }) => (
          <Col sm={4} key={header}>
            <TeamMember header={header} {...tmProps} />
          </Col>
        ))}
      </Row> */}
      <Row>
        <Col lg={8} className="mx-auto text-center">
          <p className="large text-muted">{rootContent}</p>
        </Col>
      </Row>
    </PageSection>
  );
};

Blog.propTypes = {
  className: PropTypes.string,
  frontmatter: PropTypes.object,
};

Blog.defaultProps = {
  className: null,
  frontmatter: null,
};

export default Blog;
